// extracted by mini-css-extract-plugin
export default {"configuratorMain":"css_configuratorMain__FCJgg"};